
import { StockLocationConfig } from "@/models/dossier-configs/stock-location";
import { Product } from "@/models/base";
import { ProductStock } from "@/models/base";
import { ProductWriteOffRow } from "@/models/base";
import { DossierConfigService } from "@/services/dossier-config-service";
import { ProductStockService } from "@/services/product-stock-service";
import Vue from "vue";
import AppActualStock from "./ProductActualStock.vue";
import AppLabel from "@/components/common/InfoInput.vue";

export default Vue.extend({
	data() {
		return {
			toEditWriteOff: undefined as undefined | ProductWriteOffRow,
			productStock: undefined as any | ProductStock,
			advancedStockHandling: false,
		};
	},
	props: {
		product: {
			required: true,
			type: Object as () => Product,
		}
	},
	computed: {
		actualStock():any {
			if (!this.productStock) {
				return;
			}
			return this.stockLocationConfig.getSortedLocationNames().map((l: string, i: number) => {
				return {
					text: l,
					value: i + 1,
					stock: this.productStock["Location" + (i + 1) + "Qty"]
				} as any;
			});
		},
		stockLocationConfig():StockLocationConfig {
			return DossierConfigService.getStockLocationConfig();
		}
	},
	async mounted() {
		this.productStock = await ProductStockService.getStocksByIds([this.product.StockID]);

	},
	components: {
		AppActualStock,
		AppLabel
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
